import React from 'react';
import { WorkflowsFormBlock } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsForm/WorkflowsFormBlock';
import { WorkflowsTable } from 'src/pages/ConfigurationPage/WorkflowsTab/WorkflowsTable/WorkflowsTable';
import { useConfigurationContext } from 'src/provider/ConfigurationProvider';
import { EditWorkflowBlock } from 'src/pages/ConfigurationPage/WorkflowsTab/EditWorkflowBlock/EditWorkflowBlock';

export const WorkflowsForm = ({
  formFieldsObject = {} as Record<string, any>,
  readonly = true,
  compact = false,
  customWorkflows,
  defaultWorkflows,
  onWorkflowsChange = (() => {}) as (key: any, data: any) => void,
  onWorkflowAdd = (() => {}) as (workflow: any) => void,
  onEditClick = () => {},
}: {
  formFieldsObject?: Record<string, any>;
  readonly?: boolean;
  compact?: boolean;
  customWorkflows?: any;
  defaultWorkflows?: any;
  onWorkflowsChange?: (key: any, data: any) => void;
  onWorkflowAdd?: (workflow: any) => void;
  onEditClick?: () => void;
}) => {
  const { isEditWorkflowMode } = useConfigurationContext();

  return isEditWorkflowMode ? (
    <EditWorkflowBlock
      onWorkflowAdd={onWorkflowAdd}
      onWorkflowsChange={(workflow, index) => {
        const newWorkflows = [...customWorkflows];
        newWorkflows[index] = workflow;

        onWorkflowsChange('pf_custom_workflows', newWorkflows);
      }}
      compact={compact}
      readonly={readonly}
    />
  ) : (
    <div className={'flex !flex-col gap-5 p-2'}>
      <WorkflowsFormBlock
        label={'Default Workflows'}
        compact={compact}
        isCustom={false}
        readonly={readonly}
        fields={[formFieldsObject.pf_default_workflow]}
      >
        <WorkflowsTable
          isCustom={false}
          workflows={defaultWorkflows}
          readonly={readonly}
          compact={compact}
          onChange={(workflow) => onWorkflowsChange('pf_default_workflow', workflow)}
        />
      </WorkflowsFormBlock>
      <WorkflowsFormBlock
        label={'Custom Workflows'}
        compact={compact}
        readonly={readonly}
        fields={[formFieldsObject.pf_custom_workflows]}
        onWorkflowAdd={onWorkflowAdd}
        onEditClick={onEditClick}
      >
        <WorkflowsTable
          isCustom={true}
          workflows={customWorkflows}
          readonly={readonly}
          compact={compact}
          onChange={(workflow) => onWorkflowsChange('pf_custom_workflows', workflow)}
        />
      </WorkflowsFormBlock>
    </div>
  );
};
